import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { StatsComponent } from './stats.component'
import { StatsRoutingModule } from './stats-routing.module';
import { DonutChartComponent } from './donut-chart/donut-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HttpLoaderFactory } from 'src/app/app.module';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from 'src/app/core/core.module';
import { EquipmentUtilization } from './equipment-utilization/equipment-utilization.component';
import { EquipmentUsage } from './equipment-usage/equipment-usage.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UsageByDayComponent } from './equipment-usage/usage-by-day/usage-by-day.component';
import { AverageByTimeComponent } from './equipment-usage/average-by-time/average-by-time.component';
import { AverageByEquipmentComponent } from './equipment-usage/average-by-equipment/average-by-equipment.component';
import { DetailedView } from './detailed-view/detailed-view.component';
import { DetailsViewGridComponent } from './detailed-view/details-view-grid/details-view-grid.component';
import { CustomPipesModule } from '../pipes/custom.pipe.module';
// import { TransformShortenSerialNumberPipe } from '../pipes/transform-shorten-serial-number.pipe';

@NgModule({
  declarations: [
    StatsComponent,
    DonutChartComponent,
    EquipmentUtilization,
    EquipmentUsage,
    UsageByDayComponent,
    AverageByTimeComponent,
    AverageByEquipmentComponent,
    DetailedView,
    DetailsViewGridComponent,
    // TransformShortenSerialNumberPipe
  ],
  imports: [
    CommonModule,
    StatsRoutingModule,
    NgxChartsModule,
    TranslateModule,
    CoreModule,
    NgbModule,
    CustomPipesModule
  ],
  exports:[
  ],
  providers:[DatePipe]
})
export class StatsModule { }
